import { OfferProductDto } from "@intelligems/ig-types";
import * as rtk from "@reduxjs/toolkit";
import { type PayloadAction } from "@reduxjs/toolkit";

import { IOfferProductsState } from "../types/offerProducts";

const sliceInitialOfferProductsState: IOfferProductsState = {
  isSuccess: false,
  offerProducts: [],
  storedOfferProducts: [],
};

const offerProductsSlice = rtk.createSlice({
  name: "offerProducts",
  initialState: sliceInitialOfferProductsState,
  reducers: {
    resetOfferProducts: (draft) => {
      draft.isSuccess = false;
      draft.offerProducts = [];
      draft.storedOfferProducts = [];
    },
    initOfferProducts: (
      draft,
      action: PayloadAction<{ offerProducts: OfferProductDto[] }>
    ) => {
      draft.storedOfferProducts = action.payload.offerProducts;
      draft.offerProducts = action.payload.offerProducts;
      draft.isSuccess = true;
      return draft;
    },
    setOfferTestProducts: (
      draft,
      action: PayloadAction<{
        testProducts: OfferProductDto[];
      }>
    ) => {
      if (draft.offerProducts) {
        draft.offerProducts = action.payload.testProducts;
      }
      return draft;
    },
    removeOfferTestProducts: (
      draft,
      action: PayloadAction<{
        productIds: string[];
      }>
    ) => {
      if (draft.offerProducts) {
        draft.offerProducts = draft.offerProducts.filter(
          (testProd) =>
            !action.payload.productIds.some((id) => id === testProd.id)
        );
      }
      return draft;
    },
  },
  selectors: {
    selectedOfferProducts: (state) => state.offerProducts as OfferProductDto[],
    selectedOfferProductsState: (state) => state,
  },
});

export const {
  resetOfferProducts,
  initOfferProducts,
  removeOfferTestProducts,
  setOfferTestProducts,
} = offerProductsSlice.actions;

export const offerProductsReducer = offerProductsSlice.reducer;
export const { selectedOfferProducts, selectedOfferProductsState } =
  offerProductsSlice.selectors;
